import React, {useMemo, useState} from 'react';
import {connect} from 'react-redux';
import {useQuery} from 'react-query';
import Layout from '../Layout';
import {Accordion, EmptyState, Loader} from '../../../components';
import {corruptedFile} from '../../../assets/images/images';
import {
  fetchBusinessAml,
  fetchBusinessDetails,
} from '../../../requests/queries/business360';
import * as Actions from '../../../store/actions';
import {useParams} from 'react-router-dom';

function AmlSearch({performBusinessAMLLookup}) {
  const {slug} = useParams();
  const [amlPage, setAmlPage] = useState(1);

  const {data: businessDetails, isLoading: businessDetailsLoading} = useQuery(
    ['business-details', slug],
    () => fetchBusinessDetails(slug),
  );
  const {
    data: businessAmlDetails,
    isLoading: businessAmlDetailsLoading,
    refetch: refetchAml,
  } = useQuery(['business-aml-details', slug], () => fetchBusinessAml(slug));

  const USER_PROFILE = useMemo(
    () => !businessDetailsLoading && businessDetails && businessDetails,
    [businessDetails, businessDetailsLoading],
  );

  const payload = {
    app_id: USER_PROFILE?.app_id,
    entity_name: USER_PROFILE?.business_name,
    match_score: 80,
    ongoing_monitoring: false,
  };

  const handleAMLLookupAndRefetch = async () => {
    await performBusinessAMLLookup(payload, setAmlPage);
    refetchAml();
  };

  const renderAmlContent = () => {
    switch (amlPage) {
      case 1:
        return renderEmptyState();
      case 2:
        return;
      case 3:
        return;
      default:
        return null;
    }
  };

  const renderEmptyState = () => (
    <div className="w-full pt-6 pb-6">
      <div className="bg-white80 w-full">
        <EmptyState
          body="You have not performed an AML check"
          src={corruptedFile}
          height={45}
          imageHeight={48}
          imageWidth={48}
          bodyMaxWidth="max-w-[179px]"
          buttonText="Perform AML Check"
          onClick={handleAMLLookupAndRefetch}
        />
      </div>
    </div>
  );

  return (
    <Layout pageTitle="AML Search">
      <div className="space-y-4">
        <Accordion
          title="AML"
          border
          customClasses="rounded-xl"
          customChildrenClasses="mt-2 border-t border-grey-50"
          customPadding="px-6 py-5"
          noChildPadding
          customTitleSize="text-lg"
          customTitleColor="text-grey"
        >
          <>
            {businessAmlDetailsLoading ? (
              <Loader height={50} />
            ) : (
              renderAmlContent()
            )}
          </>
        </Accordion>
      </div>
    </Layout>
  );
}

export default connect(state => state, Actions)(AmlSearch);
